import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import { InfoContainer3, InfoWrapper, TextImageSection, TextBlock, ImageBlock, ImageRow } from '../components/InfoSection/InfoElements'

import img from '../images/nowe/about.png';

import img1 from '../images/nowe/omnie1.png';
import img2 from '../images/nowe/omnie2.png';
import img3 from '../images/nowe/omnie3.png';

const About = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

  return (
    <>
    <Navbar toggle={toggle} />
    <Sidebar isOpen={isOpen} toggle={toggle} />
    <InfoContainer3 lightBg='true'>
                <InfoWrapper>
                  <div>
                    <h2>Aneta Główna – Opiekunka momentów przejścia</h2>
                    <p>
                      Nazywam się Aneta Główna. Jestem mistrzynią ceremonii pamięci życia, socjoterapeutką, coachem i projektantką. Łączę te ścieżki, aby towarzyszyć ludziom w najdelikatniejszych momentach – kiedy trzeba pożegnać kogoś bliskiego i jednocześnie znaleźć w sobie siłę, by dalej żyć. 
                    </p>
                    <ImageRow>
                        <img src={img1}></img>
                        <img src={img2}></img>
                        <img src={img3}></img>
                    </ImageRow>

                    <p>
                      Od dziecka dorastałam w przestrzeni, gdzie obecna była pamięć i strata – moi rodzice prowadzili zakład kamieniarski. Gdy jednak poczułam głębokie wołanie mojej duszy, odkryłam poruszającą rodzinną historię. Przez lata była to skrywana tajemnica – moja prababcia Maria, (której imię noszę jako drugie), w czasach wojennych została wywieziona do obozów pracy. 
                      Tam zmuszano ją do grzebania ciał w zbiorowych mogiłach. To doświadczenie głęboko mną poruszyło i pozwoliło zrozumieć, skąd od zawsze brała się we mnie tak silna potrzeba indywidualnego traktowania każdego człowieka oraz celebracji pamięci jego życia. Czuję, że moją misją jest przekuć to trudne doświadczenie przodków w wartość – w rytuały, które niosą szacunek, piękno i sens. 
                    </p>
                    <p>
                      Moja droga zawodowa była pełna zakrętów i przemian – pracowałam w rodzinnej firmie, w korporacji, w branży nieruchomości, aż w końcu znalazłam swoje miejsce w pracy z człowiekiem. Jednocześnie cały czas rozwijałam się wewnętrznie i duchowo. Wiem, jak to jest czuć się inną, niepasującą, szukać swojej tożsamości i przechodzić przez momenty, które wywracają życie do góry nogami.
                      Dziś widzę, że wszystkie te doświadczenia przygotowały mnie do tego, by być obok innych w ich najtrudniejszych chwilach. 
                    </p>
                    <hr>
                    </hr>
                    <h2>
                      🎓️Moje wykształcenie i ścieżka rozwoju
                    </h2>
                    <ul>
                      <li>
                        Studia magisterskie na Uniwersytecie Wrocławskim, kierunek Communication Design – nauczyły mnie skutecznej komunikacji, uważności i pracy z przekazem
                      </li>
                      <li>
                        Akademia Coachów by Maya Ori – certyfikowany coach, ukończone programy „Excellence Academy dla Świadomych Kobiet” oraz „Miłość Zamiast Wojny”. 
                      </li>
                      <li>
                        Instytut Bennewicza – dwa flagowe szkolenia na poziomie master: Coach kognitywny oraz Psychologia doświadczeń subiektywnych.
                      </li>
                      <li>
                        Instytut Dobrej Śmierci – szkolenie „Praca z osobą w żałobie: nowe perspektywy” oraz „Osobiste pożegnanie”. 
                      </li>
                      <li>
                        Liczne warsztaty i kursy, w które inwestuję regularnie – rocznie przeznaczam na rozwój dziesiątki tysięcy złotych, bo wierzę, że najlepsza inwestycja to inwestycja w siebie i w jakość wsparcia, jakie mogę dać innym. 
                      </li>
                    </ul>
                    <hr></hr>
                    <TextImageSection>
                    <TextBlock>
                    <h2>🌿Kim jestem poza pracą?</h2>
<p>
                      Kocham życie w każdym jego przejawie. Mam dwa psy, kota, dwa akwaria i ogród, w którym sadzę rośliny nie tylko dla ich piękna, ale też symboliki. Bliska jest mi estetyka japońska wabi-sabi – zachwyt nad prostotą, niedoskonałością i harmonią natury. Tworzę biżuterię z naturalnych kamieni, śpiewam, tańczę, kocham sztukę i to, w jaki sposób wyraża duszę człowieka.
                    </p>
                    <p>
                      Praca z ludźmi jest moim powołaniem. Widzę w nich pełnię i piękno, nawet wtedy, gdy sami go jeszcze nie dostrzegają. Wierzę, że nawet w obliczu straty można odnaleźć nowe źródła siły i miłości. 
                    </p>
                    <p>
                      Moja misja jest prosta, ale głęboka: w chwilach, gdy inni patrzą na śmierć, ja pokazuję życie.
                    </p>
                  </TextBlock>

                  <ImageBlock>
                      <img src={img} alt="Aneta" />
                  </ImageBlock>
                  </TextImageSection>
                  </div>
                </InfoWrapper>
    </InfoContainer3>
    <Footer />
    </>
  )
}

export default About